import { CommonModule as AngularCommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '../common/common.module';
import { AuthModule } from '../auth/auth.module';
import { DashboardCommonModule } from '../dashboardCommon/dashboardCommon.module';
import { DashboardMenuTabSelectorService } from '../dashboardCommon/services/dashboardMenuTabSelector.service';
import { TourModule } from '../tour/tour.module';
import { UtilModule } from '../util/util.module';
import { DashboardComponent } from './dashboard.component';
import { DashboardCfgService } from './dashboardCfg.service';
import { ClientsWoBulletinsExtendedKpiServiceHostComponent } from './kpi/components/administrativeManagementDigitalizationKpi/clientsWoBulletinsExtendedKpiServiceHost.component';
import { ClientsWoESolutionExtendedKpiServiceHostComponent } from './kpi/components/administrativeManagementDigitalizationKpi/clientsWoESolutionExtendedKpiServiceHost.component';
import { BucketsStatusExtendedKpiServiceHostComponent } from './kpi/components/bucketStatusKpi/bucketsStatusExtendedKpiServiceHost.component';
import { BucketsStatusKpiServiceHostComponent } from './kpi/components/bucketStatusKpi/bucketsStatusKpiServiceHost.component';
import { ExpiringContractsEvolutionKpiServiceHostComponent } from './kpi/components/contractsKpi/expiringContractsEvolutionKpiServiceHost.component';
import { InmediateExpiringContractsKpiServiceHostComponent } from './kpi/components/contractsKpi/inmediateExpiringContractsKpiServiceHost.component';
import { InmediateUnsignedContractsKpiServiceHostComponent } from './kpi/components/contractsKpi/inmediateUnsignedContractsKpiServiceHost.component';
import { PastExpiringContractsKpiServiceHostComponent } from './kpi/components/contractsKpi/pastExpiringContractsKpiServiceHost.component';
import { PastUnsignedContractsKpiServiceHostComponent } from './kpi/components/contractsKpi/pastUnsignedContractsKpiServiceHost.component';
import { UnsignedContractsEvolutionKpiServiceHostComponent } from './kpi/components/contractsKpi/unsignedContractsEvolutionKpiServiceHost.component';
import { DiscontinuousPermanentWorkersKpiServiceHostComponent } from './kpi/components/discontinuousPermanentWorkersKpi/discontinuousPermanentWorkersKpiServiceHost.component';
import { MonthlyTargetsKpiServiceHostComponent } from './kpi/components/monthlyTargetsKpi/monthlyTargetsKpiServiceHost.component';
import { ActiveWorkersWoMandatoryPPEKpiServiceHostComponent } from './kpi/components/occupationalRiskPreventionKpi/activeWorkersWoMandatoryPPEKpiServiceHost.component';
import { ExpiredActiveWorkersWoMedicalExaminationKpiServiceHostComponent } from './kpi/components/occupationalRiskPreventionKpi/expiredActiveWorkersWoMedicalExaminationKpiServiceHost.component';
import { ProcessingActiveWorkersWoMedicalExaminationKpiServiceHostComponent } from './kpi/components/occupationalRiskPreventionKpi/processingActiveWorkersWoMedicalExaminationKpiServiceHost.component';
import { FitActiveWorkersWoMedicalExaminationKpiServiceHostComponent } from './kpi/components/occupationalRiskPreventionKpi/fitActiveWorkersWoMedicalExaminationKpiServiceHost.component';
import { PendingActiveWorkersWoMedicalExaminationKpiServiceHostComponent } from './kpi/components/occupationalRiskPreventionKpi/pendingActiveWorkersWoMedicalExaminationKpiServiceHost.component';
import { OffersInNegotiationDOKpiServiceHostComponent } from './kpi/components/offersInNegotiationKpi/offersInNegotiationDOKpiSeviceHost.component';
import { OffersInNegotiationEvolutionDOKpiServiceHostComponent } from './kpi/components/offersInNegotiationKpi/offersInNegotiationEvolutionDOKpiSeviceHost.component';
import { OffersInNegotiationExtendedKpiServiceHostComponent } from './kpi/components/offersInNegotiationKpi/offersInNegotiationExtendedKpiSeviceHost.component';
import { OffersInNegotiationKpiServiceHostComponent } from './kpi/components/offersInNegotiationKpi/offersInNegotiationKpiSeviceHost.component';
import { InmediatePendingOrdersExtendedKpiServiceHostComponent } from './kpi/components/ordersKpi/inmediatePendingOrdersExtendedKpiServiceHost.component';
import { InmediatePendingOrdersKpiServiceHostComponent } from './kpi/components/ordersKpi/inmediatePendingOrdersKpiServiceHost.component';
import { InmediatePendingOrdersPermKpiServiceHostComponent } from './kpi/components/ordersKpi/inmediatePendingOrdersPermKpiServiceHost.component';
import { InmediatePendingOrdersTEAKpiServiceHostComponent } from './kpi/components/ordersKpi/inmediatePendingOrdersTEAKpiServiceHost.component';
import { PastPendingOrdersExtendedKpiServiceHostComponent } from './kpi/components/ordersKpi/pastPendingOrdersExtendedKpiServiceHost.component';
import { PastPendingOrdersKpiServiceHostComponent } from './kpi/components/ordersKpi/pastPendingOrdersServiceHost.component';
import { OfferingsDOKpiServiceHostComponent } from './kpi/components/visitsCallsTargetsKpi/offeringsDOKpiServiceHost.component';
import { OfferingsKpiServiceHostComponent } from './kpi/components/visitsCallsTargetsKpi/offeringsKpiServiceHost.component';
import { VisitsCallsEvolutionKpiServiceHostComponent } from './kpi/components/visitsCallsTargetsKpi/visitsCallsEvolutionKpiServiceHost.component';
import { VisitsTargetDOKpiServiceHostComponent } from './kpi/components/visitsCallsTargetsKpi/visitsTargetDOKpiServiceHost.component';
import { VisitsTargetKpiServiceHostComponent } from './kpi/components/visitsCallsTargetsKpi/visitsTargetKpiServiceHost.component';
import { AdministrativeManagementDigitalizationKpiCfgService } from './kpi/services/administrativeManagementDigitalizationKpi/administrativeManagementDigitalizationKpiCfg.service';
import { ClientsWoBulletinsDetailService } from './kpi/services/administrativeManagementDigitalizationKpi/clientsWoBulletinsDetail.service';
import { ClientsWoESolutionDetailService } from './kpi/services/administrativeManagementDigitalizationKpi/clientsWoESolutionDetail.service';
import { BucketsStatusService } from './kpi/services/bucketStatusKpi/bucketsStatus.service';
import { BucketsStatusDetailService } from './kpi/services/bucketStatusKpi/bucketsStatusDetail.service';
import { BucketStatusKpiCfgService } from './kpi/services/bucketStatusKpi/bucketsStatusKpiCfg.service';
import { ContractsKpiCfgService } from './kpi/services/contractsKpi/contractsKpiCfg.service';
import { ForecastedExpiringContractsService, InmediateExpiringContractsService, PastExpiringContractsService } from './kpi/services/contractsKpi/expiringContracts.service';
import { ForecastedExpiringContractsDetailService, InmediateExpiringContractsDetailService, PastExpiringContractsDetailService } from './kpi/services/contractsKpi/expiringContractsDetail.service';
import { ForecastedUnsignedContractsService, InmediateUnsignedContractsService, PastUnsignedContractsService } from './kpi/services/contractsKpi/unsignedContracts.service';
import { ForecastedUnsignedContractsDetailService, InmediateUnsignedContractsDetailService, PastUnsignedContractsDetailService } from './kpi/services/contractsKpi/unsignedContractsDetail.service';
import { DiscontinuousPermanentWorkersService } from './kpi/services/discontinuousPermanentWorkersKpi/discontinuousPermanentWorkers.service';
import { DiscontinuousPermanentWorkersDetailService } from './kpi/services/discontinuousPermanentWorkersKpi/discontinuousPermanentWorkersDetail.service';
import { DiscontinuousPermanentWorkersKpiCfgService } from './kpi/services/discontinuousPermanentWorkersKpi/discontinuousPermanentWorkersKpiCfg.service';
import { MonthlyTargetsService } from './kpi/services/monthlyTargetsKpi/monthlyTargetsKpi.service';
import { MonthlyTargetsKpiCfgService } from './kpi/services/monthlyTargetsKpi/monthlyTargetsKpiCfg.service';
import { ActiveWorkersWoMandatoryPPEService } from './kpi/services/occupationalRiskPreventionKpi/activeWorkersWoMandatoryPPE.service';
import { ActiveWorkersWoMandatoryPPEDetailService } from './kpi/services/occupationalRiskPreventionKpi/activeWorkersWoMandatoryPPEDetail.service';
import { ExpiredActiveWorkersWoMedicalExaminationService } from './kpi/services/occupationalRiskPreventionKpi/expiredActiveWorkersWoMedicalExamination.service';
import { ExpiredActiveWorkersWoMedicalExaminationDetailService } from './kpi/services/occupationalRiskPreventionKpi/expiredActiveWorkersWoMedicalExaminationDetail.service';
import { OccupationalRiskPreventionKpiCfgService } from './kpi/services/occupationalRiskPreventionKpi/occupationalRiskPreventionKpiCfg.service';
import { PendingActiveWorkersWoMedicalExaminationService } from './kpi/services/occupationalRiskPreventionKpi/pendingActiveWorkersWoMedicalExamination.service';
import { PendingActiveWorkersWoMedicalExaminationDetailService } from './kpi/services/occupationalRiskPreventionKpi/pendingActiveWorkersWoMedicalExaminationDetail.service';
import { ProcessingActiveWorkersWoMedicalExaminationService } from './kpi/services/occupationalRiskPreventionKpi/processingActiveWorkersWoMedicalExamination.service';
import { ProcessingActiveWorkersWoMedicalExaminationDetailService } from './kpi/services/occupationalRiskPreventionKpi/processingActiveWorkersWoMedicalExaminationDetail.service';
import { FitActiveWorkersWoMedicalExaminationService } from './kpi/services/occupationalRiskPreventionKpi/fitActiveWorkersWoMedicalExamination.service';
import { FitActiveWorkersWoMedicalExaminationDetailService } from './kpi/services/occupationalRiskPreventionKpi/fitActiveWorkersWoMedicalExaminationDetail.service';
import { OffersInNegotiationService } from './kpi/services/offersInNegotiationKpi/offersInNegotiation.service';
import { OffersInNegotiationKpiCfgService } from './kpi/services/offersInNegotiationKpi/offersInNegotiationKpiCfg.service';
import { OrdersKpiCfgService } from './kpi/services/ordersKpi/ordersKpiCfg.service';
import { InmediatePendingOrdersService, PastPendingOrdersService } from './kpi/services/ordersKpi/pendingOrders.service';
import { InmediatePendingOrdersDetailService, PastPendingOrdersDetailService } from './kpi/services/ordersKpi/pendingOrdersDetail.service';
import { PermInmediatePendingOrdersDetailService, PermPastPendingOrdersDetailService } from './kpi/services/ordersKpi/permPendingOrdersDetail.service';
import { TEAInmediatePendingOrdersDetailService, TEAPastPendingOrdersDetailService } from './kpi/services/ordersKpi/teaPendingOrdersDetail.service';
import { VisitsCallsTargetsService } from './kpi/services/visitsCallsTargetsKpi/visitsCallsTargets.service';
import { VisitsCallsTargetsKpiCfgService } from './kpi/services/visitsCallsTargetsKpi/visitsCallsTargetsKpiCfg.service';
import { StaticDashboardDefinitionComponent } from './staticDashboardDefinition.component';
import { WorkersAppealService } from './kpi/services/workersAppealKpi/workersAppeal.service';
import { WorkersAppealKpiCfgService } from './kpi/services/workersAppealKpi/workersAppealKpiCfg.service';
import { WorkersAppealDetailService } from './kpi/services/workersAppealKpi/workersAppealDetail.service';
import { WorkersAppealPendingKpiServiceHostComponent } from './kpi/components/workersAppealKpi/workersAppealPendingKpiServiceHost.component';
import { PendingOrdersFDKpiServiceHostComponent } from './kpi/components/pendingOrdersFDKpi/pendingOrdersFDKpiServiceHost.component';
import { PendingOrdersFDService } from './kpi/services/pendingOrdersFDKpi/pendingOrdersFD.service';
import { PendingOrdersFDKpiCfgService } from './kpi/services/pendingOrdersFDKpi/pendingOrdersFDKpiCfg.service';
import { PendingOrdersFDDetailService } from './kpi/services/pendingOrdersFDKpi/PendingOrdersFDDetail.service';
import { VacanciesKpiCfgService } from '../vacancies/services/vacanciesKpiCfg.service';

@NgModule({ exports: [
        DashboardComponent,
        StaticDashboardDefinitionComponent,
        ClientsWoESolutionExtendedKpiServiceHostComponent,
        ClientsWoBulletinsExtendedKpiServiceHostComponent,
        BucketsStatusKpiServiceHostComponent,
        DiscontinuousPermanentWorkersKpiServiceHostComponent,
        BucketsStatusExtendedKpiServiceHostComponent,
        PastExpiringContractsKpiServiceHostComponent,
        InmediateExpiringContractsKpiServiceHostComponent,
        ExpiringContractsEvolutionKpiServiceHostComponent,
        PastUnsignedContractsKpiServiceHostComponent,
        InmediateUnsignedContractsKpiServiceHostComponent,
        UnsignedContractsEvolutionKpiServiceHostComponent,
        OffersInNegotiationKpiServiceHostComponent,
        OffersInNegotiationExtendedKpiServiceHostComponent,
        OffersInNegotiationDOKpiServiceHostComponent,
        OffersInNegotiationEvolutionDOKpiServiceHostComponent,
        ActiveWorkersWoMandatoryPPEKpiServiceHostComponent,
        PendingActiveWorkersWoMedicalExaminationKpiServiceHostComponent,
        ExpiredActiveWorkersWoMedicalExaminationKpiServiceHostComponent,
        ProcessingActiveWorkersWoMedicalExaminationKpiServiceHostComponent,
        FitActiveWorkersWoMedicalExaminationKpiServiceHostComponent,
        PastPendingOrdersKpiServiceHostComponent,
        InmediatePendingOrdersKpiServiceHostComponent,
        InmediatePendingOrdersTEAKpiServiceHostComponent,
        InmediatePendingOrdersPermKpiServiceHostComponent,
        PastPendingOrdersExtendedKpiServiceHostComponent,
        InmediatePendingOrdersExtendedKpiServiceHostComponent,
        VisitsTargetKpiServiceHostComponent,
        VisitsCallsEvolutionKpiServiceHostComponent,
        VisitsTargetDOKpiServiceHostComponent,
        OfferingsKpiServiceHostComponent,
        OfferingsDOKpiServiceHostComponent,
        MonthlyTargetsKpiServiceHostComponent,
        WorkersAppealPendingKpiServiceHostComponent,
        PendingOrdersFDKpiServiceHostComponent
    ],
    declarations: [
        DashboardComponent,
        StaticDashboardDefinitionComponent,
        ClientsWoESolutionExtendedKpiServiceHostComponent,
        ClientsWoBulletinsExtendedKpiServiceHostComponent,
        BucketsStatusKpiServiceHostComponent,
        DiscontinuousPermanentWorkersKpiServiceHostComponent,
        BucketsStatusExtendedKpiServiceHostComponent,
        PastExpiringContractsKpiServiceHostComponent,
        InmediateExpiringContractsKpiServiceHostComponent,
        ExpiringContractsEvolutionKpiServiceHostComponent,
        PastUnsignedContractsKpiServiceHostComponent,
        InmediateUnsignedContractsKpiServiceHostComponent,
        UnsignedContractsEvolutionKpiServiceHostComponent,
        ActiveWorkersWoMandatoryPPEKpiServiceHostComponent,
        PendingActiveWorkersWoMedicalExaminationKpiServiceHostComponent,
        ExpiredActiveWorkersWoMedicalExaminationKpiServiceHostComponent,
        ProcessingActiveWorkersWoMedicalExaminationKpiServiceHostComponent,
        FitActiveWorkersWoMedicalExaminationKpiServiceHostComponent,
        OffersInNegotiationKpiServiceHostComponent,
        OffersInNegotiationExtendedKpiServiceHostComponent,
        OffersInNegotiationDOKpiServiceHostComponent,
        OffersInNegotiationEvolutionDOKpiServiceHostComponent,
        PastPendingOrdersKpiServiceHostComponent,
        InmediatePendingOrdersKpiServiceHostComponent,
        InmediatePendingOrdersTEAKpiServiceHostComponent,
        InmediatePendingOrdersPermKpiServiceHostComponent,
        PastPendingOrdersExtendedKpiServiceHostComponent,
        InmediatePendingOrdersExtendedKpiServiceHostComponent,
        VisitsTargetKpiServiceHostComponent,
        VisitsCallsEvolutionKpiServiceHostComponent,
        VisitsTargetDOKpiServiceHostComponent,
        OfferingsDOKpiServiceHostComponent,
        OfferingsKpiServiceHostComponent,
        MonthlyTargetsKpiServiceHostComponent,
        WorkersAppealPendingKpiServiceHostComponent,
        PendingOrdersFDKpiServiceHostComponent
    ], imports: [AngularCommonModule,
        CommonModule,
        AuthModule,
        UtilModule,
        NgbModule,
        FormsModule,
        DashboardCommonModule,
        TourModule,
        BrowserModule], providers: [
        DashboardCfgService,
        DashboardMenuTabSelectorService,
        DashboardMenuTabSelectorService,
        AdministrativeManagementDigitalizationKpiCfgService,
        ClientsWoESolutionDetailService,
        ClientsWoBulletinsDetailService,
        BucketStatusKpiCfgService,
        BucketsStatusService,
        BucketsStatusDetailService,
        ContractsKpiCfgService,
        PastExpiringContractsService,
        InmediateExpiringContractsService,
        ForecastedExpiringContractsService,
        PastExpiringContractsDetailService,
        InmediateExpiringContractsDetailService,
        ForecastedExpiringContractsDetailService,
        PastUnsignedContractsService,
        InmediateUnsignedContractsService,
        ForecastedUnsignedContractsService,
        PastUnsignedContractsDetailService,
        InmediateUnsignedContractsDetailService,
        ForecastedUnsignedContractsDetailService,
        OccupationalRiskPreventionKpiCfgService,
        ActiveWorkersWoMandatoryPPEService,
        ActiveWorkersWoMandatoryPPEDetailService,
        PendingActiveWorkersWoMedicalExaminationService,
        PendingActiveWorkersWoMedicalExaminationDetailService,
        ProcessingActiveWorkersWoMedicalExaminationService,
        ProcessingActiveWorkersWoMedicalExaminationDetailService,
        FitActiveWorkersWoMedicalExaminationService,
        FitActiveWorkersWoMedicalExaminationDetailService,
        ExpiredActiveWorkersWoMedicalExaminationService,
        ExpiredActiveWorkersWoMedicalExaminationDetailService,
        OffersInNegotiationKpiCfgService,
        OffersInNegotiationService,
        OrdersKpiCfgService,
        PastPendingOrdersService,
        InmediatePendingOrdersService,
        PastPendingOrdersDetailService,
        TEAPastPendingOrdersDetailService,
        PermPastPendingOrdersDetailService,
        InmediatePendingOrdersDetailService,
        TEAInmediatePendingOrdersDetailService,
        PermInmediatePendingOrdersDetailService,
        VisitsCallsTargetsKpiCfgService,
        VisitsCallsTargetsService,
        MonthlyTargetsKpiCfgService,
        MonthlyTargetsService,
        DiscontinuousPermanentWorkersKpiCfgService,
        DiscontinuousPermanentWorkersService,
        DiscontinuousPermanentWorkersDetailService,
        WorkersAppealService,
        WorkersAppealKpiCfgService,
        WorkersAppealDetailService,
        PendingOrdersFDService,
        PendingOrdersFDKpiCfgService,
        PendingOrdersFDDetailService,
        VacanciesKpiCfgService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class DashboardModule {

}
